import React from 'react'
import marked from 'marked'

import Row from '../../Shared/Row'
import Column from '../../Shared/Column'

const FAQ = (props) => (
    <Row className="block-faq" id={ props.id }>
        <Column width="8" offsetL="4" tablet="12">
        {
            props.title &&
            <h2 className="h2">{ props.title }</h2>
        }
        {
            props.questions &&
            props.questions.map( (q,k) => (
                <span key={ q.id }>
                    <h3 className="h3">{ q.question }</h3>
                    <div dangerouslySetInnerHTML={{ __html: marked(q.answer.internal.content) }} />
                </span>
            ))
        }
        </Column>
    </Row>
)

export default FAQ



// WEBPACK FOOTER //
// ./src/components/WhatAboutCollege/FAQ/index.js